import { render } from "./auth.vue?vue&type=template&id=5d7c89b6&scoped=true"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"

import "./auth.vue?vue&type=style&index=0&id=5d7c89b6&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d7c89b6"]])

export default __exports__